import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Zap } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useSite } from "../context/SiteContext";
import { trackEvent } from "../lib/analytics";

const UrgentBanner = () => {
  const { t } = useLanguage();
  const { settings } = useSite();

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      data-testid="urgent-banner"
      className="relative overflow-hidden border border-[#D4AF37]/30 bg-gradient-to-r from-[#11203A] to-[#1A2C47]"
    >
      <div className="absolute inset-y-0 start-0 w-1.5 bg-[#D4AF37]" />
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-6 py-5">
        <div className="flex items-center gap-4">
          <span className="w-11 h-11 grid place-items-center bg-[#D4AF37] text-[#0A1223] shrink-0">
            <Zap size={22} fill="currentColor" strokeWidth={0} />
          </span>
          <div>
            <p className="font-heading text-lg font-bold text-white leading-tight">{t.urgent.title}</p>
            <p className="text-sm text-slate-300">{t.urgent.text}</p>
          </div>
        </div>
        <a
          href={`https://wa.me/${String(settings?.contact?.whatsapp || "966549747549").replace(/\D/g, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="urgent-whatsapp-btn"
          onClick={() => trackEvent("whatsapp_click", { location: "urgent_banner" })}
          className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#25D366] text-white font-semibold hover:bg-[#1eb858] transition-colors duration-300 shrink-0"
        >
          <MessageCircle size={18} fill="white" strokeWidth={0} />
          {t.urgent.cta}
        </a>
      </div>
    </motion.div>
  );
};

export default UrgentBanner;
